import React, { useEffect, useState } from 'react';

import { useNavigate, useParams } from 'react-router-dom'

// Grommet

import GridLoader from "react-spinners/GridLoader";


// Appt Components
import Anchor from '../../components/simple/anchor/Anchor'
import Box from '../../components/simple/box/Box'
import ResponsiveGrid from '../../components/compound/responsiveGrid/ResponsiveGrid'

import Text from '../../components/simple/text/Text'
import LocalStorageService from '../../services/LocalStorageService.js';
import AIService from '../../services/AIService';
import { replaceTerms } from '../../utils/text';

// Shared Components
import BreadcrumbBar from '../shared/BreadcrumbBar'
import AILinkBar from './shared/AiLinkBar.js';
import ActionButton from '../../components/compound/actionButton/ActionButton.js';
import ActionBoxSmall from '../../components/compound/actionBox/ActionBoxSmall.js';

function AIServiceScreen (props) {
  const navigate = useNavigate()
  const activeOrg = LocalStorageService.get('activeOrg');
  const apiToken = LocalStorageService.get('apiToken');
  const terms = LocalStorageService.get('terms');

  const params = useParams();

  const userId = params.userid;
  const formId = params.formId;


  const [aiResponse, setAiResponse] = useState('');
  const [aiError, setAiError] = useState(false);
  const [aiThinking, setAiThinking] = useState(false);

  const [selectedAction, setSelectedAction] = useState('');
  const [availableActions, setAvailableActions] = useState({});

  const [syncingService, setSyncingService] = useState(false);


  const [sections, setSections] = useState([]);
  const [prompts, setPrompts] = useState([]);
  const [selectedPromptId, setSelectedPromptId] = useState(null);

  // useEffect(() => {
    
  //   let serviceUserTerm = lowercase(terms?.serviceUser || 'Service User')

  //   let newLabels = serviceLabels
  //   // TEMPORARY
  //   // newLabels['custom'] = '[DEVELOPMENT ONLY] Ask your own question'
    
  //   setAvailableActions(newLabels)
    
  // }, [props.terms]);


  useEffect(() => {
    getPrompts()
  }, []);


  const getPrompts = async () => {
    let response = await AIService.getPrompts(apiToken, 'Service');
    if (response) {
      setPrompts(response);
      let newSections = [];
      for (const prompt of response) {
        if (!newSections.includes(prompt.subSection)) {
          newSections.push(prompt.subSection);
        }
      }

      newSections = newSections.sort((a, b) => a?.localeCompare(b));

      setSections(newSections);
    } else {
      console.error('Error getting prompts:', response?.error || 'Unknown error');    
    }
  };

  const requestInsight = async (promptId) => {

    setSelectedPromptId(promptId);

    setAiResponse('Thinking...')


    setAiThinking(true)

    const response = await AIService.askAboutService(apiToken, promptId)

    setAiThinking(false)

    if (response?.response) {
      setAiResponse(response.response)
      setAiError(false)
    } else {
      setAiResponse('')
      setAiError(true)
    }
  }

  const syncServiceData = async () => {
    setSyncingService(true)
    const response = await AIService.syncService(apiToken)
    setSyncingService(false)
  }

  useEffect(() => {

  }, [formId])



  return (
    <>
      <BreadcrumbBar
        title="AI Insights - Service"
        path={
          <>
            <Anchor href="/">BehaviourSmart</Anchor>
            <Text color="besmartBlue" size="xsmall">
              {window.location.pathname}
            </Text>
          </>
        }
      />
            
      <AILinkBar />

      <Box
        background="white"
        direction="column"
        gap="small"
        margin={{ bottom: 'small' }}
        round="small"
      >
        <Box
          justify="between"
          pad={{ horizontal: 'medium', vertical: 'small' }}
        >
          <Text margin={{ top: 'xsmall', bottom: 'xsmall' }} size="xlarge">
            Disclaimer
          </Text>
          <Text color='secondary'>
            Our AI suggestions are for informational purposes only. Users should evaluate and apply these ideas based on their expertise. Behaviour Smart is not liable for outcomes from these suggestions. Always consult a qualified professional for personalised guidance. Please do not share data with parents or other parties that you're not authorised to.
            Please report inaccurate information or issues to <Anchor color='secondary' href="https://hello.behavioursmart.co.uk/ai-feedback" target="_blank">https://hello.behavioursmart.co.uk/ai-feedback</Anchor>
          </Text>
        </Box>
      </Box>


      <Box
        background="white"
        direction="column"
        gap="small"
        margin={{ bottom: 'small' }}
        round="small"
      >
        <Box
          justify="between"
          pad={{ horizontal: 'medium', vertical: 'small' }}
        >
          <Text margin={{ top: 'xsmall', bottom: 'xsmall' }} size="xlarge">
            Upload Service Data (Data to be queried must uploaded first). Uploaded data is persistent.
          </Text>
            <ActionButton onClick={() => syncServiceData()} label='Sync' primary />
            {syncingService && <Text>Syncing... this may take a while</Text>}
        </Box>
      </Box>

      {(aiResponse || aiError) && <Box
        background="white"
        direction="column"
        gap="small"
        margin={{ bottom: 'small' }}
        round="small"
      >
        <Box
          justify="between"
          pad={{ horizontal: 'medium', vertical: 'medium' }}
        >
          <Text margin={{ top: 'xsmall' }} size="xlarge">
            {aiResponse && <>
                <Text style={{ whiteSpace: 'pre-line' }}>        
                  <GridLoader color='#ff8300' loading={aiThinking} cssOverride={{ marginRight: '20px'}} />
                  {/* {aiResponse} */}
                  {!aiThinking && <Text style={{ whiteSpace: 'pre-line' }}>{aiResponse}</Text>}
                </Text>
            </>}
            {aiError && <Text color='red'>There was an error processing your request. Please try again.</Text>}
          </Text>
        </Box>
      </Box>}

      {sections.map((key) => (
        <>
          <Box background='white' direction='column' gap='small' round='small' flex='grow' margin={{ top: 'medium', bottom: 'medium' }}>
            <Box direction='row-responsive' justify='between' pad={{ horizontal: 'medium', vertical: 'small' }}>
                 <Text size="xlarge" weight="bold" color='secondary'>
                  {key}
                </Text>
            </Box>
          </Box>

          <ResponsiveGrid
            rows={['auto']}
            columns={{
              small: ['auto'],
              medium: ['33%', '33%', '33%'],
              large: ['33%', '33%', '33%'],
              xlarge: ['33%', '33%', '33%'],
            }}
            gap="small"
          >
            { prompts?.filter(p => p.subSection === key).map((prompt) => (
              <ActionBoxSmall
                  key={prompt.id}
                  width='100%'
                  title={replaceTerms(prompt.label, terms)}
                  onClick={() => requestInsight(prompt.id)}
                  active={parseInt(prompt.id) === parseInt(selectedPromptId)}
                /> 
            ))}

          </ResponsiveGrid>

        </>
      ))}


      <Box background='white' direction='column' gap='small' round='small' flex='grow' margin={{ top: 'medium', bottom: 'medium' }}>
        <Box direction='row-responsive' justify='between' pad={{ horizontal: 'medium', vertical: 'small' }}>
           <Text size="xlarge" weight="bold" color='secondary'>
            Improve AI Insights
          </Text>
        </Box>
      </Box>
    

      <ResponsiveGrid
        rows={['auto']}
        columns={{
          small: ['auto'],
          medium: ['33%', '33%', '33%'],
          large: ['33%', '33%', '33%'],
          xlarge: ['33%', '33%', '33%'],
        }}
        gap="small"
      > 
        <ActionBoxSmall
          width='100%'
          title={'Report inaccurate information'}
          onClick={() => window.open('https://hello.behavioursmart.co.uk/ai-feedback', '_blank')}
        />

        <ActionBoxSmall
          width='100%'
          title={'Make a suggestion'}
          onClick={() => window.open('https://hello.behavioursmart.co.uk/ai-prompts', '_blank')}
        />

      </ResponsiveGrid>

      
{/* 
      {(aiResponse || aiError) && <Box
            background="white"
            direction="column"
            gap="small"
            margin={{ bottom: 'small' }}
            round="small"
        >

            <Box direction='column' gap='xsmall' margin={{ top: 'small', bottom: 'medium', horizontal: 'medium' }}>
                <Text color='brand' size='large'>DEVELOPER DEBUG</Text>
                {aiResponse && <>
                    <Text weight='bold'>System Message</Text>
                    <Text style={{ whiteSpace: 'pre-line', marginBottom: 20 }}>{aiSystemMessage}</Text>
                    <Text weight='bold'>Prompt</Text>
                    <Text style={{ whiteSpace: 'pre-line', marginBottom: 20 }}>{aiPrompt}</Text>
                    <Text weight='bold'>Response</Text>
                    <Text style={{ whiteSpace: 'pre-line' }}>{aiResponse}</Text>
                </>}
                {aiError && <Text color='red'>There was an error processing your request. Please try again.</Text>}
            </Box>
        </Box>} */}
    </>
  );
}

export default AIServiceScreen
